import React from 'react'

const ThirdIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.73 10a.64.64 0 0 1 .64-.64h7.183a.64.64 0 0 1 .453 1.092l-3.513 3.513c2.289.273 4.178 1.972 4.178 4.19 0 2.37-2.196 4.468-4.818 4.473a4.554 4.554 0 0 1-4.029-2.227.64.64 0 1 1 1.1-.653 3.274 3.274 0 0 0 2.92 1.6c1.998 0 3.547-1.603 3.547-3.194 0-1.539-1.492-2.948-3.546-2.948h-.002c-.266 0-.531.024-.792.074a.64.64 0 0 1-.62-.23l-.013-.016a.64.64 0 0 1 .047-.852l3.543-3.543H12.37a.64.64 0 0 1-.64-.64Z"
        fill="url(#a)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.998 2.734h13.309v13.309a13.344 13.344 0 0 1-13.305 13.305l-.002-.64-.002.64A13.344 13.344 0 0 1 2.693 16.043l.64-.002-.64-.002A13.344 13.344 0 0 1 15.998 2.734ZM3.973 16.041A12.064 12.064 0 0 0 16 28.068 12.064 12.064 0 0 0 28.027 16.04V4.013H16.001A12.064 12.064 0 0 0 3.973 16.041Z"
        fill="url(#b)"
      />
      <defs>
        <radialGradient
          id="a"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-123.856 18.42 6.942) scale(23.4577 73.8369)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-38.89594 -39.06875 132.90371 -132.31583 35.987 36.32)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default ThirdIcon